import { Rocket, Heart, MapPin, TrendingUp, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const features = [{
  icon: <Rocket className="h-8 w-8 text-anyskill-purple" />,
  title: "From Employee to Founder",
  description: "Students shouldn't just clock in for minimum wage. They should be founders of their own time, building a reputation before they even graduate."
}, {
  icon: <Heart className="h-8 w-8 text-anyskill-blue" />,
  title: "Invest in Your Backyard",
  description: "When you hire locally, you're funding a student's ambition, keeping capital in your community, and mentoring the next generation of leaders."
}, {
  icon: <MapPin className="h-8 w-8 text-anyskill-orange" />,
  title: "Build Your Network",
  description: "Every project is a chance to serve neighbors who become your future network—real relationships, not anonymous transactions."
}, {
  icon: <TrendingUp className="h-8 w-8 text-anyskill-purple" />,
  title: "The Launchpad Economy",
  description: "We're not a gig economy. We're building portfolios, teaching entrepreneurial grit, and launching careers before graduation."
}];

const FeaturesSection = () => {
  return <section id="features" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="font-poppins font-bold text-3xl md:text-4xl mb-4 text-foreground">Why Choose AnySkill?</h2>
          <p className="font-inter text-muted-foreground max-w-2xl mx-auto mb-6">
            The old way of working is broken—students trade years for minimum wage at corporations that don't care, while professionals outsource to anonymous faces overseas. AnySkill rejects the transactional economy. We believe the best investment you can make is in your own community.
          </p>
          <Link to="/manifesto">
            <Button variant="outline" className="gap-2 border-anyskill-purple text-anyskill-purple hover:bg-anyskill-purple/10">
              Read Our Manifesto
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => <div key={index} className="bg-card rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="bg-background rounded-full w-16 h-16 flex items-center justify-center mb-6 shadow-sm">
                {feature.icon}
              </div>
              <h3 className="font-poppins font-semibold text-xl mb-3 text-card-foreground">{feature.title}</h3>
              <p className="font-inter text-muted-foreground">{feature.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default FeaturesSection;